import { render } from "./departmentManage.vue?vue&type=template&id=e6b686f6&scoped=true"
import script from "./departmentManage.vue?vue&type=script&lang=js"
export * from "./departmentManage.vue?vue&type=script&lang=js"

import "./departmentManage.vue?vue&type=style&index=0&id=e6b686f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6b686f6"]])

export default __exports__